import React from "react";
import { string, number } from "prop-types";

const YoutubeIcon = ({ color = "#FFF", width = 22, height = 15 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 15">
    <path
      fill={color}
      fillRule="nonzero"
      d="M21.228 2.344c.183.703.313 1.77.391 3.203l.04 1.953-.04 1.953c-.078 1.458-.208 2.54-.39 3.242-.13.443-.365.834-.704 1.172a2.708 2.708 0 0 1-1.21.703c-.678.183-2.266.313-4.766.39l-3.555.04-3.555-.04c-2.5-.077-4.088-.207-4.765-.39a2.708 2.708 0 0 1-1.211-.703 2.724 2.724 0 0 1-.703-1.172c-.183-.703-.313-1.784-.39-3.242L.33 7.5c0-.573.013-1.224.04-1.953.077-1.432.207-2.5.39-3.203.13-.469.364-.873.703-1.211A2.708 2.708 0 0 1 2.673.43C3.352.247 4.94.117 7.44.04L10.994 0l3.555.04c2.5.077 4.088.207 4.765.39.47.13.873.364 1.211.703.339.338.573.742.703 1.21zm-12.421 8.36L14.392 7.5 8.807 4.336v6.367z"
    />
  </svg>
);

YoutubeIcon.propTypes = {
  color: string,
  width: number,
  height: number
};

export default YoutubeIcon;
